module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-4-2020.svg?v=c087a0a7";